import type {
  CacheFlushDateInput,
  CacheFlushDateOutput,
} from "@/apis/shared/cacheFlushDate";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import { cacheFlushDateScheduleMeta } from "./shared/cacheFlushDate.endpoints";

/**
 * Fetch function for retrieving timestamp of when static wsf-schedule data was last updated
 */
const { fetch, useHook } = createFetchAndHook<
  CacheFlushDateInput,
  CacheFlushDateOutput
>({
  api: wsfScheduleApiMeta,
  endpoint: cacheFlushDateScheduleMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/cacheFlushDate.endpoints").cacheFlushDateScheduleGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving timestamp of when static wsf-schedule data was last updated
 */
export const fetchCacheFlushDateSchedule: FetchFactory<
  CacheFlushDateInput,
  CacheFlushDateOutput
> = fetch;

/**
 * React Query hook for retrieving timestamp of when static wsf-schedule data was last updated
 */
export const useCacheFlushDateSchedule: HookFactory<
  CacheFlushDateInput,
  CacheFlushDateOutput
> = useHook;

// Re-export with API-specific names for backward compatibility
export type CacheFlushDateScheduleInput = CacheFlushDateInput;
export type CacheFlushDateSchedules = CacheFlushDateOutput;
